export default __webpack_public_path__ + "static/stack-usage-example-1cac991abf659a297630bed385e934f8.png";